import {initViewComponentsExamples} from "../../development/view-components/examples";
import {initGridsExamples} from "../../development/grids/examples";

// import {initMediaFilesExamples} from "../../development/media-files/examples";

function registerDevelopmentComponents(components) {
	/**
	 * Development
	 */

	components['development.view-components.examples'] = {
		action: initViewComponentsExamples,
	};

	components['development.grids.examples'] = {
		action: initGridsExamples,
	};

	// components['development.media-files.examples'] = {
	// 	action: initMediaFilesExamples,
	// };

	/**
	 * Custom Components
	 */
}

export {registerDevelopmentComponents}
